import React from 'react'

import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'

import { Link as RouterLink } from 'react-router-dom'
import { useStyles } from './style'

export function ListItemLink(props) {
  const { icon, primary, to, className, id, isSelected, onSelect } = props
  const classes = useStyles()

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  )

  return (
    <li
      className={`${classes.itemMenuLink} ${
        isSelected ? classes.selected : ''
      }`}
      onClick={() => onSelect(id)}
    >
      <ListItem
        button
        dense
        component={renderLink}
        className={className}
        style={{
          margin: 0,
          padding: 0,
          backgroundColor: 'transparent'
        }}
      >
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  )
}
